// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"32cf454d","595":"c8bae1e6","690":"34fcd5ea"}[chunkId] + ".chunk.js";
};